module.exports = __webpack_public_path__ + "img/lsjc_2.f4df4c1e.png";